angular.module('unica_survey.survey_services')

.factory('SurveyDeleteService', function ($http, getBaseApiURL) {

	var surveyDeleteService = {};

	surveyDeleteService.delete = function (surveyId)
	{
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/survey/delete/' + surveyId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	return surveyDeleteService;
});